import { AuthGuard, redirectUnauthorizedTo } from '@angular/fire/auth-guard';
import { Routes } from '@angular/router';
import { AdminGuard } from 'src/app/guards/admin.guard';
import { WriterGuard } from 'src/app/guards/writer.guard';
import { EmptyRouteComponent } from 'src/app/shared/components/empty-route/empty-route.component';
import { MenuItem } from 'src/app/shared/components/sidebar-nav/sidebar-nav.dto';
import { environment } from 'src/environments/environment';
import { AiConfigComponent } from './ai-config/ai-config.component';
import { AppPhotoEditorComponent } from './app-photo-editor/app-photo-editor.component';
import { BillingUsageComponent } from './billing-usage/billing-usage.component';
import { CoursePermissionsRequestsComponent } from './course-permissions-requests/course-permissions-requests.component';
import { ModelDisplayerComponent } from './my-models/model-displayer/model-displayer.component';
import { MyModelsComponent } from './my-models/my-models.component';
import { MySpaceBillingComponent } from './my-space-billing/my-space-billing.component';
import { MySpaceComponent } from './my-space.component';
import { personalizeAppTabResolver } from './personalize-app-tab.resolver';
import { UserManagementComponent } from './user-management/user-management.component';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['login']);

export const mySpaceRouteMenuItems: MenuItem[] = [
  // { value: 'my-journey', view: 'MySpace.MyJourney', link: '/myspace/myjourney', icon: 'trending_up', isSvgIcon: false },
  // { value: 'my-models', view: 'MySpace.MyModels', link: '/myspace/my-models', icon: 'network_intel_node', isSvgIcon: false, writerOnly: true },
  // { value: 'access-requests', view: 'MySpace.UserRequests', link: '/myspace/requests', icon: 'rule', isSvgIcon: false },
  { value: 'user-management', view: 'Global.ManageUsers', link: '/myspace/user-management', icon: 'manage_accounts', isSvgIcon: false, adminOnly: true },
  { value: 'billing-usage', view: 'MySpace.Billing', link: '/myspace/billing-usage', icon: 'receipt', isSvgIcon: false, adminOnly: true },
  // { value: 'billing-v2', view: 'Billing V2', link: '/myspace/billing-v2', icon: 'receipt_long', isSvgIcon: false, adminOnly: true },
  { value: 'global-settings', view: 'MySpace.GlobalSettings', link: '/myspace/global-settings', icon: 'tune', isSvgIcon: false },
  ...(environment.enableAppCustomization
    ? [{ value: 'personalize-app', view: 'MySpace.PersonalizeApp', link: '/myspace/personalize-app', icon: 'palette', isSvgIcon: false, premiumOnly: false, adminOnly: true }]
    : []),
];

export const MySpaceRoutes: Routes = [
  {
    path: '',
    redirectTo: 'myjourney',
    pathMatch: 'full',
  },
  {
    path: '',
    component: MySpaceComponent,
    canActivate: [AuthGuard],
    data: {
      authGuardPipe: redirectUnauthorizedToLogin,
    },
    children: [
      // Obsolete profile view removed
      ...(environment.enableAppCustomization
        ? [
            {
              path: 'personalize-app',
              resolve: { _tabRedirect: personalizeAppTabResolver },
              component: EmptyRouteComponent,
            },
            {
              path: 'personalize-app/:tab',
              component: AppPhotoEditorComponent,
              canActivate: [AdminGuard],
            },
          ]
        : []),
      {
        path: 'billing',
        component: MySpaceBillingComponent,
        canActivate: [AdminGuard],
      },
      {
        path: 'billing-usage',
        component: BillingUsageComponent,
        canActivate: [AdminGuard],
      },
      // {
      //   path: 'billing-v2',
      //   loadComponent: () => import('../billing-demo/billing-demo.component').then((c) => c.BillingDemoComponent),
      //   canActivate: [AdminGuard],
      // },
      {
        path: 'user-management',
        component: UserManagementComponent,
        canActivate: [AdminGuard],
      },
      // {
      //   path: 'myjourney',
      //   component: MyJourneyComponent,
      // },
      {
        path: 'my-models',
        component: MyModelsComponent,
        canActivate: [WriterGuard],
      },
      {
        path: 'my-models/:id',
        component: ModelDisplayerComponent,
      },
      {
        path: 'requests',
        component: CoursePermissionsRequestsComponent,
        canActivate: [WriterGuard],
      },
      {
        path: 'global-settings',
        component: AiConfigComponent,
      },
    ],
  },
];
